import { FileText, Image as ImageIcon, FileSpreadsheet, Presentation, Film, Music, File, Archive, FileCode } from "lucide-react";

export const STATUS_META = {
  processing: { label: "Processing", cls: "bg-blue-500/10 text-blue-400 border-blue-500/20 animate-pulse" },
  needs_review: { label: "Needs Review", cls: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  approved: { label: "Approved", cls: "bg-violet-500/10 text-violet-300 border-violet-500/20" },
  published: { label: "Published", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  archived: { label: "Archived", cls: "bg-slate-500/10 text-slate-400 border-slate-500/20" },
  private: { label: "Private", cls: "bg-slate-500/10 text-slate-400 border-slate-500/20" },
};

export function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-500/10 text-slate-400 border-slate-500/20" };
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function ConfidenceBadge({ value }) {
  if (value == null) return null;
  const pct = Math.round(value * 100);
  const cls = pct >= 70 ? "text-emerald-400 border-emerald-500/20 bg-emerald-500/10" : pct >= 40 ? "text-amber-400 border-amber-500/20 bg-amber-500/10" : "text-red-400 border-red-500/20 bg-red-500/10";
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-mono border ${cls}`}>{pct}% conf.</span>;
}

export function kindIcon(kind, className = "w-4 h-4") {
  const map = {
    pdf: FileText, image: ImageIcon, spreadsheet: FileSpreadsheet, presentation: Presentation,
    video: Film, audio: Music, document: FileText, archive: Archive, text: FileCode,
  };
  const Ic = map[kind] || File;
  return <Ic className={className} strokeWidth={1.5} />;
}
